module.exports = __webpack_public_path__ + "static/media/leafa-win.99af68ad.png";